<script>
  import { External, M } from '../../external';
  import VideoCaptionProperties from './VideoCaptionProperties.svelte';

  export let captions = [];
  let captionPropertiesPopup = null;

  export const getCaptions = () => captions;

  //index of the caption in the captions array, -1 if new caption
  let showVideoCaptionProperties = (i) => {
    let captionHolder;
    if (i >= 0) {
      captionHolder = JSON.parse(JSON.stringify(captions[i]));
    } else {
      captionHolder = {
        isNew: true,
        lang: 'English',
        tag: 'en'
      };
    }

    captionHolder.isDefault = captions.length === 0 || i === 0;

    External.Tools.showWindow({
      noTitle: true,
      width: 450,
      isModal: true,
      withDarkBackground: true,
      buttons: [
        External.Button(M.OK, External.Button.CLASS_MIDDLE_BLUE, (popup) => {
          if (!captionHolder.lang) {
            External.Tools.showError(M.LANGUAGE_REQUIRED);
            return;
          } else if (!captionHolder.url) {
            External.Tools.showError(M.CAPTION_VTT_REQUIRED);
            return;
          } else if (!captionHolder.url.endsWith('.vtt')) {
            External.Tools.showError(M.CAPTION_VTT_EXTENSION);
            return;
          }
          let langExists = checkIfLanguageExists(captionHolder, i);
          if (langExists) {
            External.Tools.showError(M.LANGUAGE_EXISTS);
            return;
          }
          popup.close();

          if (captionHolder.isNew) {
            //add new caption
            if (captionHolder.isDefault) {
              captions.unshift(captionHolder);
            } else {
              captions.push(captionHolder);
            }
          } else {
            if (captionHolder.isDefault) {
              //set default caption
              captions.splice(i, 1);
              captions.unshift(captionHolder);
            } else {
              //update caption
              captions[i] = captionHolder;
            }
          }
          clearHolderProperties(captionHolder);
          captions = captions;
        }),
        External.Button(M.CANCEL, Button.CLASS_MIDDLE_GREY, (popup) => {
          popup.close();
        })
      ],
      action: {
        onShow: (popup, context) => {
          captionPropertiesPopup = popup;
          popup.bindComponent(
            new VideoCaptionProperties({
              target: popup.getContentArea(),
              props: {
                caption: captionHolder,
                removeCaption: removeCaption
              }
            })
          );
        }
      }
    });
  };

  let checkIfLanguageExists = (lang, index) => {
    if (index >= 0) {
      return captions.filter((e, i) => i !== index).findIndex((e) => e.tag === lang.tag) >= 0;
    } else {
      return captions.findIndex((e) => e.tag === lang.tag) >= 0;
    }
  };

  let clearHolderProperties = (holder) => {
    delete holder.isDefault;
    delete holder.isNew;
  };

  let removeCaption = (caption) => {
    External.Tools.prompt(M.DELETE, External.format(M.DEL_CONFIRM_EXT, 'ext', caption.lang), () => {
      let index = captions.findIndex((e) => e.tag === caption.tag);
      if (index >= 0) {
        captions.splice(index, 1);
        captions = captions;
      }
      if (captionPropertiesPopup) {
        captionPropertiesPopup.close();
        captionPropertiesPopup = null;
      }
    });
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left t-center mt-25">
    <a on:click={() => showVideoCaptionProperties(-1)} class="middle-button blue with-icon inline-block f-none"
      >{M.ADD_NEW_LANGUAGE}</a>
  </div>
  <div class="f-left t-center mb-25 col20">
    {#each captions as caption, i}
      <div class="col20 mt-10 f-left gray-section product-select-wrapper">
        <div class="col20 f-left ab-step center-vertically space-between">
          <h4 class="roboto">{caption.lang}</h4>
          {#if i === 0}
            <span>(default)</span>
          {/if}
          <a
            class="text-link blue-text flex-none"
            data-role="editStyling"
            on:click={() => {
              showVideoCaptionProperties(i);
            }}>{M.EDIT}</a>
        </div>
      </div>
    {/each}
  </div>
</div>
